import { render, staticRenderFns } from "./officialWebsite.vue?vue&type=template&id=6837e970&scoped=true&"
import script from "./officialWebsite.vue?vue&type=script&lang=js&"
export * from "./officialWebsite.vue?vue&type=script&lang=js&"
import style0 from "./officialWebsite.vue?vue&type=style&index=0&lang=css&"
import style1 from "./officialWebsite.vue?vue&type=style&index=1&id=6837e970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837e970",
  null
  
)

export default component.exports